/**
 * Labels the drag's `setIsCollapsed` writes for the analytics reporter behind
 * `SideNavProvider`'s `onCollapseChange`: the provider's public types carry no
 * payload, and Pluma fires the callback even when the value is unchanged.
 * Module state is safe only because Pluma invokes the callback synchronously
 * from inside `setIsCollapsed` — if a Pluma release makes it async, the
 * tripwire is the label-sequence test in wrapper.browser.test.tsx.
 */

/**
 * `drag-preview`: an uncommitted flip (midpoint crossing, same-side release,
 * aborted-drag revert). `drag`: a release on the other side of the snap point.
 */
export type NavCollapseInteraction = 'drag-preview' | 'drag';

let activeInteraction: NavCollapseInteraction | null = null;

export function withNavCollapseInteraction(interaction: NavCollapseInteraction, flipState: () => void) {
  activeInteraction = interaction;
  try {
    flipState();
  } finally {
    activeInteraction = null;
  }
}

/** `null` = track nothing (preview flip); interaction-free changes are clicks. */
export function resolveNavCollapseTrigger(): 'drag' | 'button_click' | null {
  if (activeInteraction === 'drag-preview') {
    return null;
  }
  return activeInteraction ?? 'button_click';
}
